import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Status, STATUS_SIZE_20 } from '../../../../Status'
import Text from '../../../../Text'
import { Widget } from '../../../../Widget'
import { ApplicantCreditCheckDisclosure } from '../../RentalPortalApplicantProfileTabOverview'
import { QA_NAME_APPLICANT_PROFILE_COMPLIANCE_STATUS } from '../RentalPortalApplicantProfileCompliance.constants'

import { ApplicantProfileComplianceFact } from './ApplicantProfileComplianceFact'

import * as styles from './ApplicantProfileComplianceBlock.module.css'

function ApplicantProfileComplianceBlock({
  children,
  disclosure,
  isSkeleton,
  lines,
  qaName,
  status,
  titleKey,
}) {
  const { t } = useTranslation()

  const [isDisclosureOpen, setDisclosureOpen] = useState(false)

  function handleToggleDisclosure() {
    setDisclosureOpen(!isDisclosureOpen)
  }

  return (
    <Widget
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={isSkeleton}
      qaName={qaName}
      title={t(titleKey)}
    >
      <div className={styles.content}>
        <Status
          height={STATUS_SIZE_20}
          qaName={QA_NAME_APPLICANT_PROFILE_COMPLIANCE_STATUS}
          text={status.text}
          textColor={status.textColor}
        />
        <div className={styles.lines}>
          {lines.map(line => (
            <Text isSecondary className={styles.line} key={line}>
              {line}
            </Text>
          ))}
        </div>
        {disclosure ? (
          <ApplicantCreditCheckDisclosure
            isOpen={isDisclosureOpen}
            qaName={disclosure.qaName}
            text={disclosure.text}
            onToggle={handleToggleDisclosure}
          >
            <div className={styles.facts}>
              {disclosure.facts.map(fact => (
                <ApplicantProfileComplianceFact
                  key={fact.key}
                  label={fact.label}
                  value={fact.value}
                />
              ))}
            </div>
            {disclosure.note ? (
              <Text isSecondary className={styles.line}>
                {disclosure.note}
              </Text>
            ) : null}
          </ApplicantCreditCheckDisclosure>
        ) : null}
        {children}
      </div>
    </Widget>
  )
}

export default ApplicantProfileComplianceBlock
